import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill="#FF9500"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.8928 21.8914C19.346 24.4385 15.5748 24.9888 12.4887 23.5615C12.0331 23.3781 11.6596 23.2298 11.3045 23.2298C10.3154 23.2357 9.08433 24.1947 8.44449 23.5557C7.80465 22.9157 8.76441 21.6837 8.76441 20.6886C8.76441 20.3335 8.62203 19.9666 8.43862 19.5102C7.01071 16.4245 7.56178 12.6521 10.1086 10.1058C13.3597 6.85353 18.6417 6.85353 21.8928 10.105C25.1498 13.3623 25.1439 18.6399 21.8928 21.8914Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.2829 16.3439H19.2904" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.942 16.3439H15.9495" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.6012 16.3439H12.6087" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;

